import React, { Component } from 'react'

import { connect } from 'react-redux'
import * as api from '../../api/api'
import * as actions from '../../actions'
import { ListDivider } from 'rmwc/List';
import { Button, ButtonIcon } from 'rmwc/Button';
import { Link } from 'react-router-dom'
import {
  Dialog,
  DefaultDialogTemplate,
  DialogSurface,
  DialogHeader,
  DialogHeaderTitle,
  DialogBody,
  DialogFooter,
  DialogFooterButton,
  DialogBackdrop
} from 'rmwc/Dialog';

import {TextField} from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';

import SerializeForm from 'form-serialize'

import {
  Card,
  CardPrimaryAction,
  CardMedia,
  CardAction,
  CardActions,
  CardActionButtons,
  CardActionIcons,
} from 'rmwc/Card';

import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Grid, GridCell } from 'rmwc/Grid';

import StatusMessage from '../../util/StatusMessage'
import SearchComponent from '../SearchComponent';
import ReactExport from "react-data-export";


class TQRegisteredUsers extends Component {
  constructor(props) {
    super(props)
    this.state = {
      status: '',
      errorMsg: '',
      searchStatus: false,
      page: 1,
      downloadDisable: true,
      data: {
        certification:'TQ',
        registeredUsers:[],
        message:'',
        exportData:[],
        exportPage: 1,
        partialregExport: [],
        partialregistrationExport: false
      },
      searchData: {
        searchTerm: '',
        criteria: ''
      }
    }
    
    
  }
  componentDidMount() {
    this.fetchRegData()
  }

  fetchRegData = (e) =>{
    
    let data = Object.assign({}, this.state.data)

    api.getRegisteredUsers(this.props.user.accessToken, data.certification, 0, this.state.page).then((result) => {
          
          const { status, errors} = result
          
          if (status === 'success') {
            
            data.registeredUsers = result.data
            this.setState({data:data})
          }
          else {
            this.setState({ errorMsg: 'Error in Fetching Detail' })  
          }
        })
        .catch((err) => {
          this.setState({ errorMsg: 'Error in Fetching Details' })
        })
  }

  handleSearch = (searchTerm, criteria, pageNo) => {
    let certType = 'TQ'
    let search = `admin/registered_users/search_by_criteria`
    let data = Object.assign({}, this.state.data)
    let searchData = Object.assign({}, this.state.searchData)
    searchData.searchTerm = searchTerm
    searchData.criteria = criteria
    this.setState({searchData: searchData, page: pageNo})

    let values = {
      'certType': certType,
      'searchTerm': searchTerm,
      'criteria': criteria,
      'pageNo': pageNo
    }
    api.adminRegisteredUsersSearch(this.props.user.accessToken, search, values)
    .then((result) => {
      if (result.status === 'success'){
        data.registeredUsers = result.data
        this.setState({data:data, searchStatus: true})
      }
    })
  }

  onPageTextChange = evt => {
    let page = Object.assign({}, this.state.page);
    page = evt.target.value;
    this.setState({page});
  }

  handleFetch = (e) => {
    e.preventDefault()
    if (this.state.searchStatus === false) {
      this.fetchRegData()
    }
    else {
      this.handleSearch(this.state.searchData.searchTerm, this.state.searchData.criteria, parseInt(this.state.page))
    }
  }

  handleClear = (e) => {
    e.preventDefault()
    this.fetchRegData()
    this.setState({page: 1, searchStatus: false})
  }

  handleExportData = (e, dobExport) => {
    e.preventDefault()
    let data = Object.assign({}, this.state.data)
    if(!this.state.downloadDisable){
      this.setState({downloadDisable: true})
    }
    let url = `admin/tq/export?start_tq_id=${this.state.data.exportPage}&dob_export=${dobExport}`
    api.getResponse(this.props.user.accessToken, url).then((result) => {
        const { status, errors} = result
        if (status === 'success') {
          data.exportData = result.data
          this.setState({data:data, downloadDisable: false})
        }
      })
      .catch((err) => {
       this.setState({ errorMsg: 'Error in Fetching Details', downloadDisable: true })
      })
  }



  onInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
  };

  handlePartialRegistrationExport = (e) => {
    e.preventDefault()
    let data = Object.assign({}, this.state.data)
    if(!this.state.downloadDisable){
      this.setState({downloadDisable: true})
    }
    if(data.exportPage > 0){
      let url = `admin/fetch/tq/partial/open/registration/${data.exportPage}`
      api.getResponse(this.props.user.accessToken, url).then((result) => {
        const { status, errors} = result
          if (status === 'success') {
            console.log(result)
            data.partialregExport = result.data
            this.setState({data:data, errorMsg:'', downloadDisable:false, partialregistrationExport: true})
          }
        })
        .catch((err) => {
          this.setState({ errorMsg: 'Error in Fetching Details', downloadDisable:true })
        })
    }
    else{
      this.setState({errorMsg: 'Please provide valid Start id for export'})
    }
  } 


  render(){
    let handleSearch = this.handleSearch
    let handleClear = this.handleClear
    let handleFetch = this.handleFetch
    let userListCompnent
    
    if(this.state.data.registeredUsers.length >0){
      //console.log(this.state.data.registeredUsers)
      userListCompnent = 
        ( <tbody>
            {this.state.data.registeredUsers.map(regUser => (

              <tr>
                <td>{regUser.user_id}</td>
                <td>{regUser.user_name}</td>
                <td>{regUser.first_name}</td>
                <td>{regUser.last_name}</td>
                <td>{regUser.email}</td>
                <td>{regUser.dob}</td>
                <td>{regUser.selected_exam_date}</td>
                <td>{regUser.time_slot}</td>
                <td>{regUser.exam_date_option}</td>
                <td>{regUser.coupon_code_id}</td>
                <td>{regUser.test_track}</td>
                <td>{regUser.parent_tq_test_track}</td>
                <td>{regUser.add_on_option}</td>
                <td>{regUser.amount}</td>
                <td>{regUser.payment_status}</td>
                <td>{regUser.referral_code_used}</td>
                <td>{regUser.teaching_association}</td>
                <td>{regUser.working_organization}</td>
                <td>{regUser.payment_id}</td>
                <td>{regUser.source_of_reg}</td>
                <td>{regUser.test_date}</td>
                <td>{regUser.test_center}</td>
                <td>{regUser.crated_at}</td>
              </tr>
            ))}
          </tbody>  
        )

     }


      /* Start of export component */
      let ExcelFile = ReactExport.ExcelFile;
      let ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
      let  ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

      let exportFieldsComponent = (
        <div>
          <TextField  className='text_input' label="Start Item" autoComplete="off" name="exportPage" onChange={this.onInputChange} value={this.state.data.exportPage}/>
          <Button onClick={(e) => {this.handleExportData(e, "")}}>Export</Button>
          <Button onClick={(e) => {this.handleExportData(e, "yes")}}>DOB Export</Button>
          <Button onClick={this.handlePartialRegistrationExport}>Partial Registration Export</Button>
        </div>
      )

      let exportComponent
      if(this.state.partialregistrationExport){
        exportComponent =(
          <div className="">
              {exportFieldsComponent}
              <ExcelFile element={<Button disabled={this.state.downloadDisable}>Download</Button>}>
                <ExcelSheet data={this.state.data.partialregExport} name="partialregExport">
                    <ExcelColumn label="id" value="id"/>
                    <ExcelColumn label="User Id" value="user_id"/>
                    <ExcelColumn label="User Name" value="user_name"/>
                    <ExcelColumn label="Email" value="email"/>
                    <ExcelColumn label="Phone" value="phone"/>
                    <ExcelColumn label="First Name" value="first_name"/>
                    <ExcelColumn label="Last Name" value="last_name"/>
                    <ExcelColumn label="Certification Type" value="certification_type"/>
                    <ExcelColumn label="State of Registration" value="state_of_reg"/>
                    <ExcelColumn label="Teaching Association" value="teaching_association"/>
                    <ExcelColumn label="Working Organization" value="working_organization"/>
                    <ExcelColumn label="Test Track" value="tq_test_track"/>
                    <ExcelColumn label="Add On Option" value="global_type"/>
                    <ExcelColumn label="Exam Date Option" value="exam_date_option"/>
                    <ExcelColumn label="Exam Date" value="selected_exam_date"/>
                    <ExcelColumn label="Time Slot" value="time_slot"/>
                    <ExcelColumn label="Source of Registration" value="source_of_reg"/>
                    <ExcelColumn label="Created At" value="created_at"/>
                    <ExcelColumn label="Updated At" value="updated_at"/>
                </ExcelSheet>
              </ExcelFile>
          </div>
        )
      }
      else {
        exportComponent =(
           <div>
            {exportFieldsComponent}
            <ExcelFile element={<Button disabled={this.state.downloadDisable}>Download</Button>}>
              <ExcelSheet data={this.state.data.exportData} name="TQ">
                <ExcelColumn label="user_id" value="user_id"/>
                <ExcelColumn label="user_name" value="user_name"/>
                <ExcelColumn label="email" value="email"/>
                <ExcelColumn label="phone" value="phone"/>
                <ExcelColumn label="First Name" value="first_name"/>
                <ExcelColumn label="Last Name" value="last_name"/>
                <ExcelColumn label="Date of Birth" value="dob"/>
                <ExcelColumn label="Test Track" value="tq_test_track"/>
                <ExcelColumn label="Parent Test Track" value="parent_tq_test_track"/>
                <ExcelColumn label="Add on Option" value="add_on_option"/>
                <ExcelColumn label="Selected Exam Date" value="selected_exam_date"/>
                <ExcelColumn label="Time Slot" value="time_slot"/>
                <ExcelColumn label="Exam Option" value="exam_date_option"/>
                <ExcelColumn label="Coupon Code" value="coupon_code"/> 
                <ExcelColumn label="Submission Start" value="submission_start_date"/>
                <ExcelColumn label="Submission End" value="submission_end_date"/>
                <ExcelColumn label="Type" value="global_type_name"/>
                <ExcelColumn label="payment_id" value="payment_id"/>
                <ExcelColumn label="payment_amount" value="payment_amount"/>
                <ExcelColumn label="payment_status" value="payment_status"/>
                <ExcelColumn label="Discount Code" value="discount_code"/>
                <ExcelColumn label="Referral Code Used" value="referral_code_used"/>
                <ExcelColumn label="Teaching Association" value="teaching_association"/>
                <ExcelColumn label="Working Organization" value="working_organization"/>
                <ExcelColumn label="certification_participation_id" value="certification_participation_id"/>
                <ExcelColumn label="tq_certification_id" value="tq_certification_id"/>
                <ExcelColumn label="source_of_reg" value="source_of_reg"/>
                <ExcelColumn label="Created At" value="tq_certification_created_at"/>
                <ExcelColumn label="Test Date" value="test_date"/> 
                <ExcelColumn label="Registered By" value="registered_by"/>
                <ExcelColumn label="Institution Name" value="institution"/>
              </ExcelSheet>
            </ExcelFile>
          </div>

        )

        /* end of export component */ 
      }  

    return (
        <Grid>
          <GridCell span="12">
            <div><p><b>Teaching Quotient Registered Users</b></p></div>
            <Grid>
              <GridCell span ="7">
                {exportComponent}
              </GridCell> 

              <GridCell span="5"/>
              <GridCell span="12">
                <Typography use="caption">Note for export: From start item, the next 10000 registraitons will be exported</Typography>
              </GridCell>
              <GridCell span = "4">
                <TextField  className='text_input' label="Page Number" autoComplete="off" name="page" onChange={this.onPageTextChange} value={this.state.page}/>
                <Button  onClick={((e) => handleFetch(e))}>
                  Fetch
                </Button>
              </GridCell>
              <GridCell span="8">
              <SearchComponent onHandleSearch = {handleSearch}
                onHandleClear = {handleClear} />
              </GridCell>
            </Grid>

            <div>
              <table className="admin-table">
                <th>User Id</th>
                <th>User Name</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Date of Birth</th>
                <th>Exam Date</th>
                <th>Time Slot</th>
                <th>Exam Option</th>
                <th>Coupon Id</th>
                <th>Test_Track</th>
                <th>Parent Test Track</th>
                <th>Add on Option </th>
                <th>Amount</th>
                <th>Payment status</th>
                <th>Referral Code Used</th>
                <th>Occupation</th>
                <th>organization</th>
                <th>Payment Id</th>
                <th>Source of Registration</th>
                <th>Test_Date</th>
                <th>Test_Center</th>
                <th>Created At</th>
                
                {userListCompnent}
              </table>
            </div>
            
            
          </GridCell>
        </Grid>
      )
  }

}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TQRegisteredUsers);


// WEBPACK FOOTER //
// ./src/views/admin/TQRegisteredUsers.jsx